module.exports = __webpack_public_path__ + "static/media/guildstack.1ec5cd9d.gif";